import { API } from "@/lib/api";

const SESSION_KEY = "aureon_analytics_session";

export function analyticsSession() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = globalThis.crypto?.randomUUID?.() || `session-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function track(event, properties = {}) {
  const query = new URLSearchParams(window.location.search);
  const payload = {
    event,
    session_id: analyticsSession(),
    path: `${window.location.pathname}${window.location.search}`,
    project_id: properties.project_id || null,
    unit_id: properties.unit_id || null,
    lead_id: properties.lead_id || null,
    source: query.get("utm_source"),
    medium: query.get("utm_medium"),
    campaign: query.get("utm_campaign"),
    referrer: document.referrer || null,
    properties: Object.fromEntries(Object.entries(properties).filter(([key]) => !["project_id", "unit_id", "lead_id"].includes(key))),
  };
  fetch(`${API}/analytics/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
